import axios from 'axios';
import assign from 'object-assign';
import crypto from 'crypto-js';
import Rest from 'Core/rest';

if (typeof window !== 'undefined') {
  let keyStr = 'azxde45tgj872dfgv764hjk98lp0jhgt';
  let ivStr = 'ji41nbde94zx8d76';
  axios.interceptors.request.use(
    function(config) {
      let customHeader = {};
      // PROD應該要打開
      customHeader['cryptoCode'] = '1';
      config.headers = assign({}, config.headers, customHeader);
      if (config.data !== undefined && config.data.param !== '') {
        if (false === config.url.includes(Rest.order.getOrderStatus())) {
          const key = crypto.enc.Utf8.parse(keyStr);
          const iv = crypto.enc.Utf8.parse(ivStr);
          const encoded = crypto.AES.encrypt(config.data.param, key, {
            iv: iv,
            mode: crypto.mode.CBC,
            adding: crypto.pad.Pkcs7,
          }).toString();
          config.data.param = encoded;
        }
      }
      return config;
    },
    function(error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );
  axios.interceptors.response.use(
    (response) => {
      const { data } = response;
      if (data.rtCode !== '0000') {
        return Promise.reject({
          msg: data.rtMsg,
          errCode: data.rtCode,
          errContent: data.data,
        });
      }
      let key = crypto.enc.Utf8.parse(keyStr);
      let iv = crypto.enc.Utf8.parse(ivStr);

      let decrypt = crypto.AES.decrypt(response.data.data, key, {
        iv,
        mode: crypto.mode.CBC,
        padding: crypto.pad.Pkcs7,
      });
      let decryptData = decrypt.toString(crypto.enc.Utf8);
      // console.log(response.config.url);
      // console.log(decryptData);
      return JSON.parse(decryptData);
    },
    function(error) {
      return Promise.reject(error);
    }
  );
}
export default axios;
